/**
 * Walk-in flow state machine per Flow D + REQ-014:
 *
 *   1. Initial attempt: override_overlap=false. Server returns 200 (no conflicts)
 *      OR 409 walkin_conflict { conflicting_appointments, conflicting_holds }.
 *   2. UI shows the conflict stack, asks for explicit override.
 *   3. Retry attempt: override_overlap=true. Server permits the row via partial
 *      GiST predicate; conflicting holds → cancelled_by_walkin.
 *
 * The state machine is pure; the WalkinDialog component is the renderer.
 */

import type { ApiError } from "./api.js";
import type { Appointment, Hold } from "./types.js";

export type WalkinState =
  | { status: "idle" }
  | { status: "submitting" }
  | { status: "success"; appointment: Appointment }
  | { status: "conflict"; conflicting_appointments: Appointment[]; conflicting_holds: Hold[] }
  | { status: "error"; message: string; code: string };

export function classifyError(error: ApiError): WalkinState {
  if (error.status === 409 && error.code === "walkin_conflict") {
    const details = error.details ?? {};
    return {
      status: "conflict",
      conflicting_appointments: (details.conflicting_appointments as Appointment[]) ?? [],
      conflicting_holds: (details.conflicting_holds as Hold[]) ?? []
    };
  }
  return { status: "error", message: error.message, code: error.code };
}
